import React from "react";

import {
  CircularProgress,
  DialogContent,
  makeStyles,
  Typography,
} from "@material-ui/core";

import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import { TX_STATUS } from "./constants";
import Button from "../../buttons";
import { useSelector } from "react-redux";
import { shortenAddress } from "../../../helper";
import CheckCircleOutlineRoundedIcon from "@material-ui/icons/CheckCircleOutlineRounded";
import { chainIdToNetworkInfo } from "../../../redux/web3/constants";
import Dialog from "../../Dialog";

const TransactionModal = ({
  txInfo,
  onClose = () => null,
  onExited = () => null,
}) => {
  const classes = useStyles();

  const { txStatus, txMessage, txHash } = txInfo;
  const { connectedChainId } = useSelector((state) => state.walletSlicer);

  const blockExplorer =
    chainIdToNetworkInfo[connectedChainId]?.blockExplorerUrl;
  return (
    <Dialog
      open={Boolean(txMessage)}
      TransitionProps={{
        onExited,
      }}
    >
      <DialogContent className={classes.modalMainTransaction}>
        {TX_STATUS.PENDING === txStatus && (
          <>
            <Typography variant="h3" align="center" gutterBottom>
              Transaction In Progress
            </Typography>
            <Typography variant="h4" align="center" gutterBottom>
              {txMessage}
            </Typography>

            <CircularProgress className={classes.transactionLoading} />
          </>
        )}

        {TX_STATUS.SUCCESS === txStatus && (
          <>
            <Typography variant="h3" align="center" gutterBottom>
              Transaction Successfull
            </Typography>
            <Typography variant="h4" align="center" gutterBottom>
              {txMessage}
            </Typography>
            <CheckCircleOutlineRoundedIcon className={classes.deninedIcon} />
          </>
        )}

        {Boolean(txHash) && (
          <a
            href={`${blockExplorer}/tx/${txHash}`}
            target="_blank"
            rel="noreferrer"
            className={classes.txHashText}
          >
            {shortenAddress(txHash)}
          </a>
        )}

        {TX_STATUS.REJECTED === txStatus && (
          <>
            <Typography variant="h3" align="center" gutterBottom>
              Transaction Rejected
            </Typography>
            <Typography variant="h4" align="center" gutterBottom>
              {txMessage}
            </Typography>
            <WarningRoundedIcon className={classes.deninedIcon} />
          </>
        )}
        {(TX_STATUS.REJECTED === txStatus ||
          TX_STATUS.SUCCESS === txStatus) && (
          <Button
            variant="contained"
            style={{ marginTop: "20px" }}
            onClick={onClose}
          >
            Close
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};
export default TransactionModal;

const useStyles = makeStyles((theme) => ({
  modalMainTransaction: {
    padding: "40px 40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  transactionLoading: {
    marginTop: "20px",
    color: theme.palette.secondary.main,
  },

  deninedIcon: {
    color: theme.palette.background.main,
    width: "100px",
    height: "70px",
  },

  txHashText: {
    textDecoration: "none",
    color: theme.palette.text.primary,
    transition: "all 0.2s",
    marginTop: "1.2rem",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
